import { tv } from 'tailwind-variants';

export const styles = tv({
  slots: {
    base: 'relative flex',
    section: 'lg:bg-blue-light w-full',
    container:
      'container lg:flex lg:items-end lg:justify-end lg:pr-5 xl:min-h-75',
    body: 'lg:max-w-7/12 lg:pt-13 lg:pb-16 lg:pl-10 xl:flex xl:min-h-75 xl:max-w-175 xl:flex-col xl:justify-center xl:pt-0 xl:pb-0 xl:pl-25',
    imageWrap: 'bg-blue-light container-outset mb-4 lg:mb-0 lg:bg-transparent',
    title:
      'text-2xl font-semibold lg:text-[40px] [&_sup]:top-[-.75em] [&_sup]:text-[54%]',
    text: 'mt-3 text-base font-light lg:max-w-175 lg:text-lg',
    advertisingInformer:
      'absolute top-3 left-3 lg:top-5 lg:right-10 lg:left-auto',
    advertisingInformerContent: 'max-lg:right-auto max-lg:left-0'
  }
});
